import { promiseToResult } from '../../core/api/promiseToResult'
import { AxiosInstance } from '../../core/api/axiosinstance'

export enum Period {
  MONTH = 30,
  YEAR = 365,
}

export interface Subscribe {
  currency: string
  description: string
  id: number
  name: string
  period: Period
  price: number
  option: Record<string, string | boolean>
  descriptionInfo: { isActive: boolean, value: string }[]
}

export interface GetTariffsReq {
  countryId: string | number
}
export type GetTariffsRes = {
  id: number
  description: string
  name: string
  subscribes: Subscribe[]
}[]
const getTariffs = (data: GetTariffsReq) => {
  const { countryId } = data
  return promiseToResult(AxiosInstance().get<GetTariffsRes>(
    `/app-services/tariffs?country_id=${countryId}`,
  ))
}

export const TariffAPI = {
  getTariffs,
}
